import { render, staticRenderFns } from "./chess-board-rate.vue?vue&type=template&id=5fb85592&scoped=true&"
import script from "./chess-board-rate.vue?vue&type=script&lang=js&"
export * from "./chess-board-rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb85592",
  null
  
)

export default component.exports